import { useQuery, gql } from "@apollo/client";
import { useContext } from "react";
import { useLogger } from "./useLogger";
import { LocaleContext } from "../store/providers/LocaleProvider";

const QUERY = gql`
query getCustomerCare($locale: String!) {
	htmlComponentsCollection(
		limit: 1
		where: { type: "overlay_contact" }
		locale: $locale
	) {
		items {
			backgroundColour
            title
            subtitle
            extraParameters
			elementsCollection {
				items {
					... on ContactDetails {
						companyName
						streetPostalCodeCityCountry
						serviceNumber
						phone
						workingHours
						localNumber
					}
				}
			}
		}
	}
}`;

export const useCustomerCare = () => {
    const {logger} = useLogger();
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {loading, data, error} = useQuery(QUERY, {variables: { locale: localeUppercase}, errorPolicy: "all"});

    const componentData = data?.htmlComponentsCollection?.items;

    if(error?.message) {
        logger(error?.message, "error", "useCustomerCare", error?.stack);
    }
    return {
        componentData,
        loading,
        error
    };
};
